<script setup>

</script>

<template>
  <div>
    selected a shop first
  </div>
</template>

<style scoped>

</style>